export default function UnMaskIcon() {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 8.75C7.9665 8.75 8.75 7.9665 8.75 7C8.75 6.0335 7.9665 5.25 7 5.25C6.0335 5.25 5.25 6.0335 5.25 7C5.25 7.9665 6.0335 8.75 7 8.75Z"
        fill="#7953D2"
      />
      <path
        d="M13.755 6.23065C12.9267 5.05232 10.6167 2.33398 7 2.33398C3.38333 2.33398 1.07333 5.05232 0.245 6.23065C-0.0816667 6.69732 -0.0816667 7.31565 0.245 7.77065C1.07333 8.94898 3.38333 11.6673 7 11.6673C10.6167 11.6673 12.9267 8.94898 13.755 7.77065C14.0817 7.31565 14.0817 6.68565 13.755 6.23065ZM7 9.91732C6.22645 9.91732 5.48459 9.61003 4.9376 9.06305C4.39062 8.51606 4.08333 7.7742 4.08333 7.00065C4.08333 6.2271 4.39062 5.48524 4.9376 4.93826C5.48459 4.39128 6.22645 4.08398 7 4.08398C7.77355 4.08398 8.51541 4.39128 9.06239 4.93826C9.60938 5.48524 9.91667 6.2271 9.91667 7.00065C9.91667 7.7742 9.60938 8.51606 9.06239 9.06305C8.51541 9.61003 7.77355 9.91732 7 9.91732Z"
        fill="#7953D2"
      />
    </svg>
  );
}
